import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelect } from '@ngx-formly/primeng/select';
import { Select, SelectModule } from 'primeng/select';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-select-type',
  imports: [
    ReactiveFormsModule, FormlyModule, SelectModule
  ],
  templateUrl: './select-type.type.html',
  styleUrl: './select-type.type.scss',
})
export class SelectType extends FieldType<FormlyFieldSelect> {
  private _options: any[] = [];

  ngOnInit() {
    const options = this.props.options || [];
    
    if (this.isObservable(options)) {
      options.subscribe(opts => {
        this._options = opts;
      });
    } else {
      this._options = options;
    }
  }

  get getOptions(): any[] {
    return this._options;
  }

  private isObservable(value: any): value is Observable<any[]> {
    return value && typeof value.subscribe === 'function';
  }
}
